import { c as _c } from "react/compiler-runtime";
import ExperiencePrice from './ExperiencePrice';
const ExperiencePrices = t0 => {
    const $ = _c(7);
    const { type, prices } = t0;
    let t1;
    if ($[0] !== prices || $[1] !== type) {
        let t2;
        if ($[3] !== type) {
            t2 = p => <ExperiencePrice key={p.ageRange.lower} type={type} price={p}/>;
            $[3] = type;
            $[4] = t2;
        }
        else {
            t2 = $[4];
        }
        t1 = prices.map(t2);
        $[0] = prices;
        $[1] = type;
        $[2] = t1;
    }
    else {
        t1 = $[2];
    }
    let t2;
    if ($[5] !== t1) {
        t2 = <>{t1}</>;
        $[5] = t1;
        $[6] = t2;
    }
    else {
        t2 = $[6];
    }
    return t2;
};
export default ExperiencePrices;
